/**
 * The role a concept's administrator holds.
 *
 * T-106 renamed it from `COMPANY_ADMIN` to `CONCEPT_ADMIN` in the API, along
 * with the label users see. The rename is a data migration, so for as long as
 * one deployed database has not run it — and for as long as a session issued
 * before it is still alive — both codes name the same role and every check has
 * to accept either. Nothing here decides which is current; it only refuses to
 * make that a per-call-site guess.
 *
 * Drop `COMPANY_ADMIN` once no environment can still hand it back.
 */
export const CONCEPT_ADMIN_ROLE_CODES = ["CONCEPT_ADMIN", "COMPANY_ADMIN"] as const;

/** Its display name, in both spellings, lower-cased for comparison. */
export const CONCEPT_ADMIN_ROLE_NAMES = ["concept admin", "company admin"] as const;

export function isConceptAdminRoleCode(code: string | undefined): boolean {
  return code != null && (CONCEPT_ADMIN_ROLE_CODES as readonly string[]).includes(code);
}

export function isConceptAdminRoleName(name: string | undefined): boolean {
  const normalized = name?.trim().toLowerCase();
  return normalized != null && (CONCEPT_ADMIN_ROLE_NAMES as readonly string[]).includes(normalized);
}
